import React from "react";
import { HighScore } from "../types";
import { CloseIcon, TrophyIcon } from "./icons";

interface HighScoresModalProps {
  scores: HighScore[];
  onClose: () => void;
}

const HighScoresModal: React.FC<HighScoresModalProps> = ({
  scores,
  onClose,
}) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="high-scores-title"
    >
      <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 w-full max-w-md relative border-4 border-teal-500">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 rounded-full hover:bg-gray-200 transition-colors"
          aria-label="Close high scores"
        >
          <CloseIcon />
        </button>
        <div className="text-center mb-6">
          <div className="flex justify-center items-center gap-3">
            <TrophyIcon />
            <h1
              id="high-scores-title"
              className="text-3xl font-bold text-gray-800"
            >
              Top Formulators
            </h1>
          </div>
        </div>
        {scores.length > 0 ? (
          <ol className="list-decimal list-inside space-y-3 text-lg text-gray-700">
            {scores.map((score, index) => (
              <li
                key={index}
                className="flex justify-between items-center bg-gray-50 p-3 rounded-lg shadow-sm"
              >
                <span className="font-semibold">
                  {index + 1}. {score.name}
                </span>
                <span className="font-bold text-teal-600">{score.score}</span>
              </li>
            ))}
          </ol>
        ) : (
          <p className="text-center text-gray-600 text-lg mt-4">
            No high scores yet. Be the first!
          </p>
        )}
      </div>
    </div>
  );
};

export default HighScoresModal;
